import React, { useEffect } from 'react';
import { useBooking } from '../context/BookingContext';

const WidgetLoader = () => {
    const { dispatch } = useBooking();
    
    useEffect(() => {
        // Check if already processed
        const alreadyProcessed = sessionStorage.getItem('widgetProcessed');
        if (alreadyProcessed === 'true') {
            console.log('📝 Widget already processed, skipping');
            return;
        }
        
        const searchParams = new URLSearchParams(window.location.search);
        const fromWidget = searchParams.get('from_widget');
        
        if (fromWidget === 'true') {
            console.log('📝 WidgetLoader: Setting auto-search flag');
            
            // Set flag for auto-search in RoomSelection
            sessionStorage.setItem('shouldAutoSearch', 'true');
            sessionStorage.setItem('widgetProcessed', 'true');
            
            // DON'T clean the URL at all - let it stay
            // The BookingContext already saved the data to sessionStorage
            
            // If you MUST clean the URL, do it after a longer delay
            setTimeout(() => {
                if (window.history.replaceState) {
                    const cleanUrl = window.location.pathname;
                    window.history.replaceState({}, document.title, cleanUrl);
                    console.log('🧹 WidgetLoader cleaned URL');
                }
            }, 1000);
        }
    }, [dispatch]);
    
    return null;
};

export default WidgetLoader;